import React from 'react'
import { Link } from 'react-router-dom'

function NavSix() {
    const serviceLinks = [
        { label: 'Medical Billing & Revenue Cycle Management', to: '/medical-billing' },
        { label: 'Cybersecurity Services', to: '/cybersecurity' },
        { label: 'Call Center & Customer Support', to: '/call-center' },
        { label: 'Professional Ebook & Whitepaper Writing', to: '/ebook-whitepaper-writing' },
    ]

    const scrollToTop = () => {
        // Needed because clicking the same route doesn't trigger React Router scroll.
        try {
            window.scrollTo({ top: 0, behavior: 'smooth' })
        } catch {
            window.scrollTo(0, 0)
        }
    }
    return (
        <div>
            <nav className="nav-main mainmenu-nav d-none d-xl-block">
                <ul className="mainmenu">
                    <li>
                        <Link
                            className="nav-link"
                            to="/"
                            onClick={scrollToTop}
                        >
                            Home
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="nav-link"
                            to="/about-us"
                            onClick={scrollToTop}
                        >
                            About
                        </Link>
                    </li>
                    <li>
                        <Link
                            className="nav-link"
                            to="/industries"
                            onClick={scrollToTop}
                        >
                            Industries
                        </Link>
                    </li>
                    <li className="has-droupdown">
                        <Link className="nav-link" to="#">
                            Services
                        </Link>
                        <ul className="submenu menu-link3">
                            {serviceLinks.map((item, i) => (
                                <li key={i}>
                                    <Link to={item.to} onClick={scrollToTop}>
                                        {item.label}
                                    </Link>
                                </li>
                            ))}
                        </ul>
                    </li>
                    <li>
                        <Link className="nav-item" to="/contactus" onClick={scrollToTop}>
                            Contact us
                        </Link>
                    </li>
                </ul>
            </nav>
        </div>
    )
}

export default NavSix
